import React, { Component, Fragment } from "react";

import { Metric } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class PocketWatchRecentViewing extends Component {
  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <div className="mt-2 row d-flex align-items-end">
          {data.hours_of_viewing_last_month ? (
            <div className="col-4 col-md-4">
              <Heading size={6} className={"mb-1"}>
                Hours of Viewing Last Month
              </Heading>
              <Metric {...data.hours_of_viewing_last_month} size={"md"} />
            </div>
          ) : null}

          {data.total_active_users_last_month ? (
            <div className="mb-4 col-4 col-md-4 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Total Active Users
              </Heading>
              <Metric {...data.total_active_users_last_month} size={"md"} />
            </div>
          ) : null}

          {data.hours_users_last_month ? (
            <div className="mb-4 col-4 col-md-4 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Hours/User
              </Heading>
              <Metric {...data.hours_users_last_month} size={"md"} />
            </div>
          ) : null}
        </div>
        <div className="mt-2 row d-flex align-items-end mt-4">
          {data.hours_of_viewing_last_week ? (
            <div className="col-4 col-md-4">
              <Heading size={6} className={"mb-1"}>
                Hours of Viewing Last Week
              </Heading>
              <Metric {...data.hours_of_viewing_last_week} size={"md"} />
            </div>
          ) : null}

          {data.total_active_users_last_week ? (
            <div className="mb-4 col-4 col-md-4 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Total Active Users
              </Heading>
              <Metric {...data.total_active_users_last_week} size={"md"} />
            </div>
          ) : null}

          {data.hours_users_last_week ? (
            <div className="mb-4 col-4 col-md-4 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Hours/User
              </Heading>
              <Metric {...data.hours_users_last_week} size={"md"} />
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default PocketWatchRecentViewing;
